import React, { useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import GeneralSettingsColumn from './GeneralSettingsColumn';

export default function ComplexSettingsColumns() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const intl = useIntl();
  const { formatMessage } = intl;

  const categoryList = [
    { value: 1, label: formatMessage({ id: 'menu.settings_complex.general' }), component: GeneralSettingsColumn },
  ];

  const selectedItem = categoryList.length === 1
    ? categoryList[0]
    : categoryList.find(item => item.value === selectedCategory);
  const Component = selectedItem && selectedItem.component ? selectedItem.component : null;
  return (
    <>
      {categoryList.length > 1 ? (
        <div className="settings-category frame">
          <div className="settings-header">
            <div className="settings-label">{formatMessage({ id: 'settings.complex.category' })}</div>
            <div className="settings-buttons" />
          </div>
          <div className="settings-list-wrapper">
            <div className="settings-list custom-scroll-theme">
              {categoryList.map((item, key) => (
                <div
                  key={key}
                  onClick={() => {
                    setSelectedCategory(item.value);
                  }}
                  className={classNames('settings-menu-item', { selected: selectedCategory === item.value })}
                >{item.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}
      {Component ? <Component /> : <div className="settings-options frame" />}
    </>
  );
}
